export default "__VITE_ASSET__PYsoa0tt__"